module.exports = __webpack_public_path__ + "static/portfolio2-bffeabc09f8ee9f2281ed521128b82ca.png";